import React from 'react';
import { connect } from 'react-redux';
import { MembersContainer, MembersContent, EmptyMembersContainer, ListContainer } from './style';
import { RightHeader } from './RightHeader';
import { Row } from '../../Layouts';
import { Text } from '../../UI/Text';
import { Loading } from '../WithLoading/Loading';
import { EmptyState } from '../WithEmptyState/EmptyState';
import {
    MembersEmptyState,
    BookersEmptyState,
    ClassNotSelectedState,
} from '../../Components/BannerEmptyStats/BannerEmptyStats';
import CheckInRow from '../../Components/Rows/CheckInRow';
import { ClassesActionCreators } from '../../../Store/ActionCreators/ClassesActionCreators';

class ClassCheckInDisplay extends React.Component {
    componentDidUpdate(prevProps) {
        const { id } = this.props;

        if (id && id !== prevProps.id) {
            this.props.getClassBookers(id);
            this.props.getClassMembers(id);
        }
    }

    checkIn = (userId, planMemberId) => {
        const { id } = this.props;

        this.props.checkInUser(id, userId, planMemberId);
    };

    checkOut = (userId, planMemberId) => {
        const { id } = this.props;

        this.props.checkOutUser(id, userId, planMemberId);
    };

    getCheckedInCount = (bookers, members) => {
        let checkedInArray = [];

        bookers.forEach(booker => {
            if (booker.isChecked) checkedInArray.push(booker.id);
        });

        members.forEach(member => {
            if (member.isChecked && !checkedInArray.includes(member.id)) checkedInArray.push(member.id);
        });

        return checkedInArray.length;
    };

    getSpacesleftCount = (totalSeats, checkedIn) => {
        return totalSeats - checkedIn;
    };

    render() {
        const {
            classBookersLoading,
            classMembersLoading,
            bookers,
            members,
            spacesLeft,
            totalClassSeat,
            gym,
        } = this.props;
        const checkedInCount = this.getCheckedInCount(bookers, members);
        const spacesLeftCount = this.getSpacesleftCount(totalClassSeat, checkedInCount);

        return this.props.id ? (
            <MembersContainer>
                <RightHeader {...this.props} />
                <MembersContent>
                    <ListContainer>
                        <BookersHeader checkedCount={checkedInCount} totalSeats={totalClassSeat} />

                        <Loading isLoading={classBookersLoading}>
                            <EmptyState isEmpty={bookers.length === 0} emptyState={BookersEmptyState}>
                                {bookers.map((booker, index) => (
                                    <CheckInRow
                                        onCheckIn={this.checkIn}
                                        onCheckOut={this.checkOut}
                                        gymInfo={{ ...gym }}
                                        {...booker}
                                        key={`${index}b`}
                                        index={index}
                                    />
                                ))}
                            </EmptyState>
                        </Loading>
                    </ListContainer>

                    <ListContainer>
                        <MembersHeader spacesLeft={spacesLeftCount} />

                        <Loading isLoading={classMembersLoading}>
                            <EmptyState isEmpty={members.length === 0} emptyState={MembersEmptyState}>
                                {members.map((member, index) => (
                                    <CheckInRow
                                        bookers={bookers}
                                        availableSpaces={spacesLeft}
                                        memberRow={true}
                                        onCheckIn={this.checkIn}
                                        onCheckOut={this.checkOut}
                                        gymInfo={{ ...gym }}
                                        index={index}
                                        {...member}
                                        key={`${index}m`}
                                    />
                                ))}
                            </EmptyState>
                        </Loading>
                    </ListContainer>
                </MembersContent>
            </MembersContainer>
        ) : (
            <EmptyMembersContainer>
                <ClassNotSelectedState />
            </EmptyMembersContainer>
        );
    }
}

const BookersHeader = ({ checkedCount, totalSeats }) => (
    <Row marginBottom={'10px'} width={'100%'} justify={'space-between'}>
        <Text uppercase small opacity={0.5} weight={'bold'}>
            Booked
        </Text>
        <Text uppercase small opacity={0.5} weight={'bold'}>
            {checkedCount} / {totalSeats} Checked in
        </Text>
    </Row>
);

const MembersHeader = ({ spacesLeft }) => (
    <Row marginTop={'20px'} marginBottom={'20px'} width={'100%'} justify={'space-between'}>
        <Text uppercase small opacity={0.5} weight={'bold'}>
            All members
        </Text>
        <Text uppercase small opacity={0.5} weight={'bold'}>
            {spacesLeft} Spaces available
        </Text>
    </Row>
);

const mapStateToProps = ({
    classes: {
        statuses: { classBookersLoading, classMembersLoading },
        currentClass: { bookers, members },
    },
}) => ({
    classBookersLoading,
    classMembersLoading,
    bookers,
    members,
});

const mapDispatchToProps = dispatch => ({
    getClassBookers: classId => dispatch(ClassesActionCreators.getClassBookersRequest(classId)),
    getClassMembers: classId => dispatch(ClassesActionCreators.getClassMembersRequest(classId)),
    checkInUser: (classId, userId, planMemberId, callback) =>
        dispatch(ClassesActionCreators.checkInUserRequest(classId, userId, planMemberId, callback)),
    checkOutUser: (classId, userId, planMemberId, callback) =>
        dispatch(ClassesActionCreators.checkOutUserRequest(classId, userId, planMemberId, callback)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ClassCheckInDisplay);



// WEBPACK FOOTER //
// ./src/UI/Containers/CheckIn/ClassCheckInDisplay.js